import { render, staticRenderFns } from "./tags-home.vue?vue&type=template&id=74fd0b64&"
import script from "./tags-home.vue?vue&type=script&lang=ts&"
export * from "./tags-home.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports